import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import { getMonthName } from "../General/Utility";
import { toast, ToastContainer } from "react-toastify";

const FeeReportingPrint = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [Month, setMonth] = useState("");
  const [Year, setYear] = useState("");
  const [FeeTypeName, setFeeTypeName] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalReceiveableFee, setTotalReceiveableFee] = useState(0);
  const [totalReceivedFee, setTotalReceivedFee] = useState(0);
  const [totalPendingFee, setTotalPendingFee] = useState(0);

  useEffect(() => {
    document.title = "Fee Reporting Print";

    setLoading(true);
    const urlParams = new URLSearchParams(window.location.search);
    const month = urlParams.get("Month");
    const year = urlParams.get("Year");
    const wingId = urlParams.get("Wing_Id") || 0;
    const feetype = urlParams.get("FeeTypeId");

    setMonth(month);
    setYear(year);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: 1,
      pageSize: 10000,
      ReportMonth: month,
      ReportYear: year,
      Wing_Id: wingId,
      FeeTypeId: feetype,
    };

    axios({
      method: "post",
      url: config.base_url + "Reports/GetFeeReport",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code == 1) {
          setLedger(
            Array.isArray(response.data.ListofRecords)
              ? response.data.ListofRecords
              : []
          );
          setTotalRecords(response.data.totalRecords || 0);
          setTotalReceiveableFee(response.data.TotalReceiveableFee || 0);
          setTotalReceivedFee(response.data.TotalReceivedFee || 0);
          setTotalPendingFee(response.data.TotalPendingFee || 0);
          setFeeTypeName(response.data.Fee_Type_Name || "");
        } else {
          setLedger([]);
          setTotalRecords(0);
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoading(false);
      })
      .catch(function () {
        setLedger([]);
        setLoading(false);
      });
  }, [AccessKey, UserID, MemberType]);

  const renderLedger = () => {
    if (listOfLedger != null && listOfLedger.length > 0) {
      let count = 1;
      return listOfLedger.map((item, index) => (
        <tr key={index}>
          <td>{count++}</td>
          <td>{item.Student_ID}</td>
          <td>{item.Registration_No}</td>
          <td>{item.Student_Name}</td>
          <td>{item.Father_Name}</td>
          <td>
            {item.Wing_Name}, {item.Class_Name}, {item.Section_Name}
          </td>
          <td className="text-end">{item.TotalReceiveableFee}</td>
          <td className="text-end">{item.TotalReceivedFee}</td>
          <td className="text-end">{item.TotalPendingFee}</td>
        </tr>
      ));
    }
    return (
      <tr>
        <td colSpan="9">
          <h4
            className="mt-3"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ToastContainer />
      <Page orientation="landscape" size="a4">
        <table className="table table-sm table-bordered table-print">
          <thead>
            <tr>
              <th colSpan={9}>
                <PrintHeader
                  title={`${FeeTypeName} — ${getMonthName(Month)} ${Year} (${totalRecords} students)`}
                />
              </th>
            </tr>
            <tr>
              <th colSpan={9} className="fw-normal">
                Source: <code>tblADLedger</code> with filters <code>Is_Deleted = 0</code>, <code>Is_Active = 1</code>, selected fee code, and challan prefix <code>YYMM%</code>.
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td className="text-center" colSpan="9">
                  <Spinner animation="border" role="status"></Spinner>
                </td>
              </tr>
            ) : (
              <>
                <tr>
                  <th>Sr.#</th>
                  <th>Student ID</th>
                  <th>Reg. No</th>
                  <th>Student Name</th>
                  <th>Father Name</th>
                  <th>Class Details</th>
                  <th className="text-end">Receiveable Fee</th>
                  <th className="text-end">Received Fee</th>
                  <th className="text-end">Pending Fee</th>
                </tr>
                {renderLedger()}
                <tr>
                  <th colSpan={6} className="text-end">
                    Totals
                  </th>
                  <th className="text-end">{totalReceiveableFee}</th>
                  <th className="text-end">{totalReceivedFee}</th>
                  <th className="text-end">{totalPendingFee}</th>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </Page>
    </>
  );
};

export default FeeReportingPrint;
